import { createFileRoute } from '@tanstack/react-router'
import PositiveImagery from '@/components/Exercises/Positive-Imagery/PositiveImagery'

export const Route = createFileRoute("/(content)/adults/exercises/(shared)/positive-imagery/exercise")(
  {
    component: RouteComponent,
    head: () => ({
      meta: [
        {
          title: "An Exercise Through Positive Imagery - HAMD",
        },
      ],
    }),
    beforeLoad: () => ({
      title: "positiveImagery.title",
      navbar: {
      showTitle: true,
    },

    }),
  }
);

function RouteComponent() {
  return <PositiveImagery />
}
